"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStudioError = void 0;
const constants_1 = require("./constants");
const localizeUtils_1 = require("../../../common/localizeUtils");
class AppStudioError {
}
exports.AppStudioError = AppStudioError;
AppStudioError.FileNotFoundError = {
    name: "FileNotFoundError",
    message: (filePath) => [
        (0, localizeUtils_1.getDefaultString)("error.common.FileNotFoundError", filePath),
        (0, localizeUtils_1.getLocalizedString)("error.common.FileNotFoundError", filePath),
    ],
};
AppStudioError.AuthServiceAPIFailedError = {
    name: "AuthServiceAPIFailed",
    message: (e, requestPath, apiName) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.authServiceApiFailed", e.name, e.message, apiName),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.authServiceApiFailed", e.name, e.message, requestPath),
    ],
};
AppStudioError.TeamsAppCreateFailedError = {
    name: "TeamsAppCreateFailed",
    message: (error) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppCreateFailed", error === null || error === void 0 ? void 0 : error.message),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppCreateFailed", error === null || error === void 0 ? void 0 : error.displayMessage),
    ],
};
AppStudioError.TeamsAppUpdateFailedError = {
    name: "TeamsAppUpdateFailed",
    message: (teamsAppId, error) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppUpdateFailed", teamsAppId, error.message),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppUpdateFailed", teamsAppId, error.displayMessage),
    ],
};
AppStudioError.InvalidTeamsAppIdError = {
    name: "InvalidTeamsAppId",
    message: (teamsAppId) => [
        (0, localizeUtils_1.getDefaultString)("error.teamsApp.InvalidAppIdError", teamsAppId),
        (0, localizeUtils_1.getLocalizedString)("error.teamsApp.InvalidAppIdError", teamsAppId),
    ],
};
AppStudioError.TeamsAppNotExistsError = {
    name: "TeasmAppNotExists",
    message: (teamsAppId) => [
        (0, localizeUtils_1.getDefaultString)("error.teamsApp.AppIdNotExistError", teamsAppId),
        (0, localizeUtils_1.getLocalizedString)("error.teamsApp.AppIdNotExistError", teamsAppId),
    ],
};
AppStudioError.ValidationFailedError = {
    name: "ManifestValidationFailed",
    message: (errors) => [
        (0, localizeUtils_1.getDefaultString)("plugins.appstudio.validationFailedNotice") + " " + errors.join("\n"),
        (0, localizeUtils_1.getLocalizedString)("plugins.appstudio.validationFailedNotice") + " " + errors.join("\n"),
    ],
};
AppStudioError.SyncManifestFailedError = {
    name: "SyncManifestFailed",
    message: (errors) => [
        (0, localizeUtils_1.getDefaultString)("plugins.appstudio.syncManifestFailedNotice") + " " + errors.join("\n"),
        (0, localizeUtils_1.getLocalizedString)("plugins.appstudio.syncManifestFailedNotice") + " " + errors.join("\n"),
    ],
};
AppStudioError.TeamsAppPublishFailedError = {
    name: "TeamsAppPublishFailed",
    message: (teamsAppId, requestPath) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.publishFailed", teamsAppId) +
            ` Request path: ${requestPath}`,
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.publishFailed", teamsAppId) +
            ` Request path: ${requestPath}`,
    ],
};
AppStudioError.TeamsPackageBuildError = {
    name: "TeamsPackageBuildError",
    message: (error) => {
        var _a, _b;
        return [
            (_a = error.message) !== null && _a !== void 0 ? _a : (0, localizeUtils_1.getDefaultString)("error.appstudio.buildError"),
            (_b = error.displayMessage) !== null && _b !== void 0 ? _b : (0, localizeUtils_1.getLocalizedString)("error.appstudio.buildError"),
        ];
    },
};
AppStudioError.CheckPermissionFailedError = {
    name: "CheckPermissionFailed",
    message: (error) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.checkPermissionFailed", error.message),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.checkPermissionFailed", error.message),
    ],
};
AppStudioError.GrantPermissionFailedError = {
    name: "GrantPermissionFailed",
    message: (errorMessage, id) => [
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `${constants_1.Constants.PERMISSIONS.name}: ${id}. ` +
            (0, localizeUtils_1.getDefaultString)("error.appstudio.grantPermissionFailed", errorMessage),
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `${constants_1.Constants.PERMISSIONS.name}: ${id}. ` +
            (0, localizeUtils_1.getLocalizedString)("error.appstudio.grantPermissionFailed", errorMessage),
    ],
};
AppStudioError.ListCollaboratorFailedError = {
    name: "ListCollaboratorFailedError",
    message: (error) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.listCollaboratorFailed", error.message),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.listCollaboratorFailed", error.message),
    ],
};
AppStudioError.UpdateManifestWithInvalidAppError = {
    name: "UpdateManifestWithInvalidAppError",
    message: (appId) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.updateManifestInvalidApp", appId),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.updateManifestInvalidApp", appId),
    ],
};
AppStudioError.InvalidCapabilityError = {
    name: "InvalidCapabilityError",
    message: (capability) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.invalidCapability", capability),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.invalidCapability", capability),
    ],
};
AppStudioError.CapabilityExceedLimitError = {
    name: "CapabilityExceedLimitError",
    message: (capability) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.capabilityExceedLimit", capability),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.capabilityExceedLimit", capability),
    ],
};
AppStudioError.StaticTabNotExistError = {
    name: "StaticTabNotExist",
    message: (index) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.staticTabNotExist", index),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.staticTabNotExist", index),
    ],
};
AppStudioError.CapabilityNotExistError = {
    name: "CapabilityNotExist",
    message: (capability) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.capabilityNotExist", capability),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.capabilityNotExist", capability),
    ],
};
AppStudioError.TeamsAppCreateConflictError = {
    name: "TeamsAppCreateConflict",
    message: () => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppCreateConflict"),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppCreateConflict"),
    ],
};
AppStudioError.TeamsAppCreateConflictWithPublishedAppError = {
    name: "TeamsAppCreateConflictWithPublishedApp",
    message: () => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppCreateConflictWithPublishedApp"),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppCreateConflictWithPublishedApp"),
    ],
};
AppStudioError.TeamsAppPublishConflictError = {
    name: "TeamsAppPublishConflict",
    message: (teamsAppId) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppPublishConflict", teamsAppId),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppPublishConflict", teamsAppId),
    ],
};
AppStudioError.TeamsAppRequiredPropertyMissingError = {
    name: "TeamsAppMissingRequiredCapability",
    message: (property, path) => [
        (0, localizeUtils_1.getDefaultString)("error.appstudio.teamsAppRequiredPropertyMissing", property, path),
        (0, localizeUtils_1.getLocalizedString)("error.appstudio.teamsAppRequiredPropertyMissing", property, path),
    ],
};
//# sourceMappingURL=errors.js.map